import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import RestaurantDemo from "./RestaurantDemo.js";
import Menu from "../components/restaurants/Menu.js";
import Footer from "../components/Footer.js";

const Demo = () => {
	const { t } = useTranslation();

	return (
		<>
			<Helmet>
				<title>{t("seo.restaurantDemo.title")}</title>
				<meta
					name="description"
					content={t("seo.restaurantDemo.description")}
				/>
				<link rel="canonical" href="https://applaby.com/restaurantes/demo" />
			</Helmet>

			<Menu />
			<RestaurantDemo />
			<Footer />
		</>
	);
};

export default Demo;
